import {createReducer, on} from '@ngrx/store';
import * as NotificationActions from './notification.actions';
import {Notification} from '../notification.model';

export interface NotificationState {
  list: Notification[];
  selected?: Notification | null;
  error?: any;
  loading: boolean;
}

export const notificationFeatureKey = 'notification';

export const initialState: NotificationState = {
  list: [],
  selected: null,
  loading: false,
  error: null,
};

export const notificationReducer = createReducer(
  initialState,

  on(NotificationActions.loadNotifications, (state) => ({...state, list: [], loading: true})),
  on(NotificationActions.loadNotificationsSuccess, (state, {notifications}) => ({
    ...state,
    list: notifications,
    loading: false,
    error: null,
  })),
  on(NotificationActions.loadNotificationsFailure, (state, {error}) => ({
    ...state,
    error,
    loading: false,
  })),

  on(NotificationActions.loadNotificationSuccess, (state, {notification}) => ({
    ...state,
    selected: notification,
  })),

  on(NotificationActions.updateNotificationSuccess, (state, {id, read, hide}) => ({
    ...state,
    list: state.list.map(n =>
      n.id === id
        ? {
          ...n,
          ...(read !== undefined ? {is_read: read} : {}),
          ...(hide !== undefined ? {hide} : {})
        }
        : n
    )
  })))
